import i18n from '../../i18nextConf';

export const popoverOptions = [
	{ id: 1, text: i18n.t('edit_name') },
	// { id: 2, text: i18n.t('delete_text') },
];
